// src/i18n/home.ts —— 06 agent-portal A-02（概览）；06 未给英文的标「本计划定稿」（待回写 06）
// 0045 代理加价定价：返佣费率废弃，原「我的费率卡」改为「我的收益卡」（本月开卡差价 / 充值差价 / 汇率差三格 + 我的售价入口）
export const I18N_AGENT_HOME = {
  zh: {
    settleDaily: '每日 {settleTime} 自动结算（{timezone}）', // [改写 key] 06 A-02 / X-40
    dailyCommission: '每日佣金 (USDT)', // [改写 key] 对客评审 2026-10-15 #26：佣金单位 USDT
    myRates: '我的收益', // [改写 key] 0045：原「我的费率」
    rateNote: '名下用户按你的售价付费；开卡每张赚「你的售价 − 上级售价」，充值按费率差计入你的收益。', // [改写 key] 0045：原返佣差额说明
    kpiDirect: '直推 {n}', // [新增 key] S-66
    kMonthOpen: '本月开卡差价', // [新增 key] 0045
    kMonthTopup: '本月充值差价', // [新增 key] 0045
    kMonthFx: '本月汇率差', // [新增 key] 0045
    pricesEntry: '开卡价与充值费率在「我的售价」设置', // [新增 key] 0045
    goPrices: '设置售价', // [新增 key] 0045
    walletBound: '平台钱包绑定', // [新增 key] R-08
    walletUnbound: '未绑定（联系平台代绑后可提佣到平台钱包）', // [新增 key] R-08
    fxTitle: '用户充值兑换汇率', fxOpen: '查看与调整汇率', fxBase: '平台基础汇率', fxCurrent: '当前报价', fxBand: '允许范围',
    fxDraft: '代理报价（1 USDT 入账多少 USDT，留空继承平台）', fxSave: '保存报价', fxHistory: '调价历史', fxMore: '查看更多',
    fxAgent: '代理报价生效', fxFallback: '超出范围，按平台价执行', fxInherited: '继承平台价', fxInvalid: '报价必须在当前允许范围内，最多 6 位小数。',
  },
  en: {
    settleDaily: 'Daily at {settleTime} ({timezone})',
    dailyCommission: 'Daily commission (USDT)',
    myRates: 'My earnings',
    rateNote: "Your users pay your prices. You earn (your price − your upline's) per card, and the rate spread on top-ups.",
    kpiDirect: 'Direct {n}',
    kMonthOpen: 'Card markup (month)',
    kMonthTopup: 'Top-up markup (month)',
    kMonthFx: 'FX spread (month)',
    pricesEntry: 'Card prices and top-up rates are set in “My prices”',
    goPrices: 'Set prices',
    walletBound: 'Wallet binding',
    walletUnbound: 'Not bound (ask the platform to bind an account to withdraw to the platform wallet)', // 本计划定稿
    fxTitle: 'User deposit exchange rate', fxOpen: 'View and adjust rate', fxBase: 'Platform base rate', fxCurrent: 'Current rate', fxBand: 'Allowed band',
    fxDraft: 'Agent rate (USDT credited per 1 USDT; blank inherits platform)', fxSave: 'Save rate', fxHistory: 'Rate history', fxMore: 'Show more',
    fxAgent: 'Agent rate active', fxFallback: 'Outside band; platform rate applies', fxInherited: 'Inherit platform rate', fxInvalid: 'Rate must be within the allowed band, with up to 6 decimal places.',
  },
} as const;

// TD-805：与原型字典重名的键须显式登记才覆盖原型值（06 A-02 [改写 key]）
export const REWRITES_AGENT_HOME: readonly string[] = ['settleDaily', 'dailyCommission', 'myRates', 'rateNote'];
